import { render, staticRenderFns } from "./MoveNode.vue?vue&type=template&id=18e8963a&"
import script from "./MoveNode.vue?vue&type=script&lang=js&"
export * from "./MoveNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports